import {
  default as Icon,
  default as MaterialCommunityIcons,
} from '@expo/vector-icons/MaterialCommunityIcons';
import { TextStyle, View } from 'react-native';
import { Text } from 'react-native-paper';
import { FormFactor } from '../themes';
import { themedStyleSheet } from '../themes/themedStyleSheet';

export enum SectionHeaderVariant {
  Desktop = 'Desktop',
  Mobile = 'Mobile',
}

export interface SectionHeaderProps {
  title: string;
  icon: React.ComponentProps<typeof MaterialCommunityIcons>['name'];
  variant: FormFactor;
}

export const SectionHeader = (props: SectionHeaderProps) => {
  const containerStyle = styles[`${props.variant}_Container`];
  const textStyle = styles[`${props.variant}_Text`];
  const iconStyle = styles[`${props.variant}_Icon`];

  return (
    <View style={containerStyle}>
      <Icon name={props.icon} style={iconStyle} />
      <Text style={textStyle}>{props.title}</Text>
    </View>
  );
};

// `role` is the factory parameter, already resolved to the mode `themedStyleSheet`
// is building this particular sheet for — not the live `Colors.role` Proxy,
// which would freeze at whichever mode was active when this module first
// loaded. Shared shape kept as plain TextStyle helpers (not module-scope
// consts holding colors) so nothing here can go stale on a theme flip.
const baseText: TextStyle = {
  letterSpacing: 0,
  lineHeight: 28,
  fontWeight: '700',
  textAlign: 'left',
};

const styles = themedStyleSheet((role) => ({
  Desktop_Container: {
    alignItems: 'center',
    flexDirection: 'row',
  },
  Desktop_Text: {
    ...baseText,
    fontSize: 22,
    color: role.textStrong,
  },
  Desktop_Icon: {
    paddingRight: 8,
    fontSize: 24,
    color: role.textStrong,
  },
  Mobile_Container: {
    flex: 1,
    width: '100%',
    alignItems: 'center',
    flexDirection: 'row',
    backgroundColor: role.surfaceActive,
    borderStyle: 'solid',
    borderColor: role.borderStrong,
    borderBottomWidth: 0.5,
    padding: 20,
    justifyContent: 'flex-start',
  },
  Mobile_Text: {
    ...baseText,
    fontSize: 22,
    color: role.textStrong,
  },
  Mobile_Icon: {
    paddingRight: 5,
    fontSize: 20,
    color: role.textStrong,
  },
}));
